enum SuperUserRole {
  EGODACT_USER = 'EGODACT_USER',
  LEIDEN_USER = 'LEIDEN_USER',
}

export default SuperUserRole;
